export default "__VITE_ASSET__qs$aggUm__"